import { graphql } from "gql";

const EDIT_DISTRIBUTION_GROUP_NOTIFICATIONS_MUTATION = graphql(`
  mutation EditDistributionGroupNotifications(
    $id: ID!
    $isNotifications: Boolean!
  ) {
    editDistributionGroup(
      id: $id
      input: { isNotifications: $isNotifications }
    ) {
      id
      notificationUserIdList
    }
  }
`);

export default EDIT_DISTRIBUTION_GROUP_NOTIFICATIONS_MUTATION;
